import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import cleanObj from 'utils/cleanObj';
import FilteredListing from './index';

// Script to initialise Filter Listing React component on all .listing-app elements
$('.listing-app').each(function () {
    const appID = $(this).data('app-id');
    const $apiDataDiv = $(`.${appID}-api-json`);
    const $apiFilterDataDiv = $(`.${appID}-api-filter-json`);
    const $apiDetailDataDiv = $(`.${appID}-api-detail-json`);

    // Early return if div target is not specified
    if (!appID || !$apiDataDiv.length) { return; }

    // Setup props
    const props = {
        dataURL: $apiDataDiv.data('api-url'),
        filterUrl: $apiFilterDataDiv.data('api-filter-url'),
        data: $apiDataDiv.html(),
        filterData: $apiFilterDataDiv.html(),
        detailData: $apiDetailDataDiv.html(),
        listingAppID: appID,
        tileType: $apiDataDiv.data('tile-type'),
        dataFrequency: $apiDataDiv.data('refresh-frequency'),
        tileContainerColumnClass: $apiDataDiv.data('tile-container-column-class'),
        tileContainerTilesWrap: $apiDataDiv.data('tile-container-tile-wrap'),
        filtersLayout: $apiDataDiv.data('filters-layout'),
        itemsPerPage: $apiDataDiv.data('items-per-page'),
        activeFiltersLabel: $apiDataDiv.data('active-filters-label'),
        sortBy: $apiDataDiv.data('sort-by'),
        keywordSearchableFields: $apiDataDiv.data('keyword-searcheable-field').split(','),
        keywordPlaceholderText: $apiDataDiv.data('keyword-placeholder-text'),
        headerTitle: $apiDataDiv.data('title'),
        headerSubtitle: $apiDataDiv.data('subtitle'),
        headerButtonText: $apiDataDiv.data('export-button-text'),
        headerEdocketName: $apiDataDiv.data('header-edocket-name'),
        refID: $apiDataDiv.data('ref-id'),
        edocketID: $apiDataDiv.data('edocket-id'),
        bearerToken: `bearer ${$apiDataDiv.data('bearer-token')}`,
        showActiveFilters: $apiDataDiv.data('show-active-filters'),
        companySelectionPage: $apiDataDiv.data('company-selection-page'),
        logo: $apiDataDiv.data('logo'),
        companyName: $apiDataDiv.data('company-name'),
        refType: $apiDataDiv.data('ref-type')
    };

    // Remove any empty prop settings to let the default prop values kick in
    cleanObj(props);

    ReactDOM.render(
        React.createElement(FilteredListing, props, null),
        $(this)[0]
    );
});
